module.exports = __webpack_public_path__ + "img/free_shopping.5a791779.png";